// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3Xp-y","log":"ModalInventoryLogs_log__1USHA","date":"ModalInventoryLogs_date__1cAOp","userName":"ModalInventoryLogs_userName__3mHoO"};